
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-slate-900 via-slate-800 to-emerald-900 text-white py-16">
        <div className="container mx-auto px-6">
          <h1 className="text-5xl font-bold mb-6">About Yazan Al Homsi</h1>
          <p className="text-xl text-emerald-400">
            Venture Capitalist &amp; ESG Investment Specialist
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Photo */}
            <div className="lg:col-span-1">
              <div className="bg-gradient-to-br from-white to-blue-50 rounded-lg shadow-lg p-6">
                <img
                  src="https://static.readdy.ai/image/ee065e9bd9a3572df85d23349f7436d0/4cca4d038ed49be2260837dca2203475.png"
                  alt="Yazan Al Homsi - Venture Capitalist and CFA Charterholder"
                  className="w-full rounded-lg object-cover"
                />
              </div>
            </div>

            {/* Content */}
            <div className="lg:col-span-2">
              <div className="bg-gradient-to-br from-white to-emerald-50 rounded-lg shadow-lg p-8">
                <h2 className="text-3xl font-bold text-slate-900 mb-6">
                  Biography
                </h2>

                <div className="prose prose-lg text-gray-700 space-y-6">
                  <p>
                    Yazan Al Homsi is a distinguished venture capitalist and{' '}
                    <strong>CFA Charterholder</strong> specializing in small‑cap
                    sustainability, clean technology, and healthcare investments.
                    Born in Saudi Arabia, he graduated from McGill University
                    with a Finance degree in 2004, finishing in the{' '}
                    <strong>top 5% of his class</strong> with distinction in
                    financial analysis and corporate finance.
                  </p>

                  <p>
                    After roles at Imperial Oil and co‑founding Café Noir bistro
                    in Montreal, Yazan Al Homsi built his expertise with over{' '}
                    <strong>12 years at PricewaterhouseCoopers Middle East,
                    rising to Director level</strong>. As a{' '}
                    <strong>CFA Charterholder</strong>, he founded Founders
                    Round Capital in Vancouver in 2017, followed by Catalyst
                    Communications DMCC in Dubai in 2018.
                  </p>

                  <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">
                    Investment Philosophy
                  </h3>
                  <p>
                    Yazan Al Homsi&apos;s investment approach is ESG‑first,
                    focusing on companies that deliver both financial returns
                    and positive environmental and social impact. His most
                    notable success was Medicago, where he helped grow the
                    company from less than $10M to a $357M acquisition by
                    Mitsubishi and Philip Morris in 2013.
                  </p>

                  <p>
                    Through Founders Round Capital and Catalyst Communications
                    DMCC, Yazan Al Homsi has built a bridge between Middle
                    Eastern capital and North American innovation, facilitating
                    partnerships that drive both financial returns and
                    meaningful environmental impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Details */}
      <section className="py-20 bg-gradient-to-r from-white via-blue-50 to-emerald-50">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-16">
            Current Portfolio
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Portfolio Item 1 */}
            <div className="bg-gray-50 rounded-lg p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-emerald-500 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-recycle-line text-xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900">
                  Aduro Clean Technologies
                </h3>
              </div>
              <p className="text-lg font-bold text-emerald-600 mb-4">
                NASDAQ: ADUR
              </p>
              <p className="text-gray-700">
                AI‑powered recycling technology achieving 95% efficiency in a
                $300B market. Strategic partnership with TotalEnergies (EPA:
                TTE) and Fortune 500 partnerships validate the technology&apos;s
                commercial potential.
              </p>
            </div>

            {/* Portfolio Item 2 */}
            <div className="bg-gray-50 rounded-lg p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-leaf-line text-xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900">
                  Charbone Hydrogen
                </h3>
              </div>
              <p className="text-gray-600 mb-4">Green Hydrogen</p>
              <p className="text-gray-700">
                Leading green hydrogen production technology with Quebec and
                Michigan facilities, addressing the growing demand for clean
                energy solutions.
              </p>
            </div>

            {/* Additional portfolio items can be added here following the same structure */}
          </div>
        </div>
      </section>

      {/* Credentials */}
      <section className="py-20 bg-gradient-to-l from-slate-100 via-blue-100 to-emerald-100">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-16">
            Credentials &amp; Experience
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                CFA Charterholder
              </h3>
              <p className="text-gray-700">
                Chartered Financial Analyst certification demonstrating
                expertise in investment analysis and portfolio management.
              </p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-graduation-cap-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                McGill University
              </h3>
              <p className="text-gray-700">
                Finance degree, 2004, graduated in top 5% of class with
                distinction in financial analysis and corporate finance.
              </p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                PwC Director
              </h3>
              <p className="text-gray-700">
                12+ years as Director at PwC Middle East, leading major
                financial advisory and investment projects.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
